var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAimeLogoRow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 113,
    viewBox: "0 0 305 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0683594,
    y: 0.492188,
    width: 112,
    height: 112,
    rx: 25.4545,
    fill: "url(#paint0_linear_229_4922)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.1111 83.5566C88.1111 85.2653 87.5674 86.7022 86.48 87.8672C85.3927 88.9546 83.9946 89.4982 82.2859 89.4982C80.6549 89.4982 79.2568 88.9546 78.0918 87.8672C77.0044 86.7022 76.4608 85.2653 76.4608 83.5566V33.6932C76.4608 31.9845 77.0044 30.5864 78.0918 29.4991C79.2568 28.334 80.6549 27.7515 82.2859 27.7515C83.9946 27.7515 85.3927 28.334 86.48 29.4991C87.5674 30.5864 88.1111 31.9845 88.1111 33.6932V83.5566Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0787 47.794C28.3767 46.5329 25.1144 47.6968 24.3291 50.5732C22.8454 56.0072 22.8266 61.7724 24.3239 67.2698C26.2971 74.5148 30.7757 80.8253 36.9633 85.0794C43.1509 89.3334 50.6466 91.2554 58.1177 90.5036C65.5889 89.7518 72.5514 86.3749 77.7673 80.9733C82.9833 75.5717 86.1147 68.4954 86.6049 61.0025C87.0951 53.5097 84.9122 46.0857 80.4445 40.0506C75.9767 34.0155 69.5135 29.7603 62.2039 28.0416C56.6575 26.7374 50.8966 26.9577 45.5177 28.6304C42.6705 29.5158 41.6214 32.8169 42.9761 35.4731C44.3309 38.1293 47.5863 39.1058 50.5002 38.4733C53.5235 37.8172 56.6773 37.8344 59.7323 38.5528C64.5546 39.6867 68.8184 42.4939 71.7659 46.4753C74.7134 50.4568 76.1534 55.3545 75.83 60.2976C75.5067 65.2408 73.4408 69.9092 69.9998 73.4727C66.5587 77.0362 61.9655 79.264 57.0366 79.76C52.1078 80.256 47.1627 78.988 43.0807 76.1815C38.9986 73.375 36.0441 69.2119 34.7423 64.4323C33.9176 61.4042 33.7901 58.2529 34.3402 55.2085C34.8703 52.2743 33.7806 49.055 31.0787 47.794Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4854 58.9313C61.4854 62.5459 58.5552 65.4761 54.9406 65.4761C51.326 65.4761 48.3958 62.5459 48.3958 58.9313C48.3958 55.3167 51.326 52.3865 54.9406 52.3865C58.5552 52.3865 61.4854 55.3167 61.4854 58.9313Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0967 36.9337C25.7476 35.633 25.7084 33.4849 27.0091 32.1358C28.3098 30.7868 30.4578 30.7476 31.8069 32.0483L53.9042 53.3532C55.2533 54.6539 55.2925 56.802 53.9918 58.1511C52.6911 59.5001 50.543 59.5393 49.1939 58.2386L27.0967 36.9337Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6753 27.8531C16.2452 28.1204 15.6872 29.8714 16.699 30.9168L23.2152 37.6492C23.6524 38.1009 24.2913 38.2959 24.9062 38.1652L30.0338 37.0756C30.7495 37.0081 31.4191 36.5261 31.6318 35.7269L33.0515 30.3926C33.209 29.8011 33.0594 29.1701 32.6533 28.7121L26.5399 21.8183C25.5876 20.7444 23.8256 21.1391 23.4224 22.5166L22.1025 27.0257L17.6753 27.8531Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.905 78.24C198.905 79.323 198.561 80.2338 197.872 80.9722C197.182 81.6614 196.296 82.006 195.213 82.006C194.179 82.006 193.293 81.6614 192.555 80.9722C191.866 80.2338 191.521 79.323 191.521 78.24V46.6353C191.521 45.5523 191.866 44.6661 192.555 43.9769C193.293 43.2385 194.179 42.8693 195.213 42.8693C196.296 42.8693 197.182 43.2385 197.872 43.9769C198.561 44.6661 198.905 45.5523 198.905 46.6353V78.24Z",
    fill: "url(#paint1_linear_229_4922)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.49 30.2422C214.081 30.2422 214.697 30.3899 215.337 30.6852C215.977 30.9806 216.469 31.3991 216.813 31.9406L235.569 60.5177L232.394 60.37L251.52 31.9406C252.307 30.8083 253.316 30.2422 254.547 30.2422C255.532 30.2422 256.393 30.6114 257.132 31.3498C257.919 32.039 258.313 32.9251 258.313 34.0082V78.24C258.313 79.323 257.968 80.2338 257.279 80.9722C256.59 81.6614 255.679 82.006 254.547 82.006C253.366 82.006 252.406 81.6614 251.667 80.9722C250.978 80.2338 250.633 79.323 250.633 78.24V40.8017L252.996 41.3186L236.751 66.0559C236.406 66.499 235.963 66.8928 235.422 67.2374C234.88 67.5328 234.314 67.6559 233.723 67.6066C233.182 67.6559 232.616 67.5328 232.025 67.2374C231.483 66.8928 231.04 66.499 230.696 66.0559L215.041 41.6878L216.813 38.7341V78.24C216.813 79.323 216.469 80.2338 215.78 80.9722C215.14 81.6614 214.278 82.006 213.195 82.006C212.161 82.006 211.3 81.6614 210.611 80.9722C209.971 80.2338 209.651 79.323 209.651 78.24V34.0082C209.651 32.9744 210.02 32.0883 210.758 31.3498C211.546 30.6114 212.457 30.2422 213.49 30.2422Z",
    fill: "url(#paint2_linear_229_4922)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.648 82.7444C283.562 82.7444 280.018 81.9075 277.015 80.2338C274.012 78.5108 271.674 76.1724 270 73.2187C268.375 70.2158 267.563 66.7944 267.563 62.9545C267.563 58.6224 268.425 54.9303 270.148 51.8781C271.92 48.7767 274.209 46.4138 277.015 44.7892C279.821 43.1154 282.799 42.2786 285.95 42.2786C288.362 42.2786 290.651 42.7708 292.817 43.7554C294.983 44.6908 296.903 46.0199 298.577 47.7429C300.3 49.4167 301.654 51.4105 302.638 53.7242C303.623 55.9887 304.14 58.4748 304.189 61.1823C304.14 62.1669 303.746 62.9792 303.008 63.6191C302.269 64.2591 301.408 64.5791 300.423 64.5791H271.698L269.926 58.3025H297.691L296.288 59.6316V57.7856C296.189 56.0626 295.623 54.5611 294.589 53.2811C293.556 51.952 292.276 50.9428 290.75 50.2536C289.224 49.5152 287.624 49.1459 285.95 49.1459C284.473 49.1459 283.045 49.3921 281.667 49.8844C280.338 50.3274 279.132 51.0659 278.049 52.0997C277.015 53.1335 276.178 54.5119 275.538 56.2349C274.947 57.9086 274.652 60.0008 274.652 62.5115C274.652 65.2191 275.218 67.582 276.35 69.6004C277.483 71.6188 279.009 73.1941 280.929 74.3263C282.848 75.4094 284.965 75.9509 287.279 75.9509C289.101 75.9509 290.602 75.7786 291.783 75.434C292.965 75.0401 293.95 74.5725 294.737 74.031C295.525 73.4895 296.214 72.9726 296.805 72.4803C297.543 72.0372 298.282 71.8157 299.02 71.8157C299.906 71.8157 300.645 72.1357 301.235 72.7756C301.826 73.3664 302.121 74.0802 302.121 74.9171C302.121 76.0001 301.58 76.9847 300.497 77.8708C299.168 79.1507 297.322 80.283 294.959 81.2676C292.645 82.2521 290.208 82.7444 287.648 82.7444Z",
    fill: "url(#paint3_linear_229_4922)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.257 78.2402C183.257 79.3232 182.913 80.234 182.224 80.9724C181.534 81.6616 180.648 82.0062 179.565 82.0062C178.532 82.0062 177.645 81.6616 176.907 80.9724C176.218 80.234 175.873 79.3232 175.873 78.2402V46.6355C175.873 45.5525 176.218 44.6664 176.907 43.9772C177.645 43.2387 178.532 42.8695 179.565 42.8695C180.648 42.8695 181.534 43.2387 182.224 43.9772C182.913 44.6664 183.257 45.5525 183.257 46.6355V78.2402Z",
    fill: "url(#paint4_linear_229_4922)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.518 30.5655C194.614 29.7871 192.431 30.6967 191.742 32.6345C191.694 32.7696 191.646 32.9048 191.599 33.0402C190.92 34.9816 192.049 37.0596 194.02 37.6479L194.164 37.6908C196.055 38.2554 198.038 37.1763 198.694 35.3149C199.351 33.4535 198.484 31.3694 196.657 30.6224L196.518 30.5655Z",
    fill: "url(#paint5_linear_229_4922)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.109 55.5729C145.396 54.7736 143.329 55.5113 142.831 57.3345C141.89 60.7787 141.879 64.4328 142.828 67.9172C144.078 72.5093 146.917 76.5091 150.839 79.2054C154.761 81.9017 159.511 83.1199 164.247 82.6434C168.982 82.1669 173.395 80.0265 176.701 76.6029C180.007 73.1792 181.992 68.6941 182.303 63.9449C182.614 59.1957 181.23 54.4902 178.398 50.665C175.566 46.8398 171.47 44.1428 166.837 43.0534C163.321 42.2268 159.67 42.3664 156.261 43.4266C154.456 43.9878 153.791 46.0801 154.65 47.7636C155.508 49.4472 157.572 50.0662 159.419 49.6653C161.335 49.2494 163.334 49.2603 165.27 49.7157C168.327 50.4343 171.029 52.2136 172.897 54.7372C174.766 57.2607 175.678 60.365 175.473 63.4981C175.268 66.6312 173.959 69.5901 171.778 71.8488C169.597 74.1074 166.686 75.5195 163.562 75.8338C160.438 76.1482 157.303 75.3445 154.716 73.5657C152.129 71.7869 150.256 69.1482 149.431 66.1187C148.908 64.1995 148.827 62.2021 149.176 60.2725C149.512 58.4127 148.821 56.3722 147.109 55.5729Z",
    fill: "url(#paint6_linear_229_4922)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.381 62.6321C166.381 64.9231 164.524 66.7803 162.233 66.7803C159.942 66.7803 158.085 64.9231 158.085 62.6321C158.085 60.341 159.942 58.4838 162.233 58.4838C164.524 58.4838 166.381 60.341 166.381 62.6321Z",
    fill: "url(#paint7_linear_229_4922)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.585 48.6894C143.73 47.865 143.705 46.5035 144.529 45.6484C145.354 44.7933 146.715 44.7685 147.57 45.5929L161.576 59.0966C162.431 59.921 162.456 61.2825 161.632 62.1375C160.807 62.9926 159.446 63.0175 158.591 62.1931L144.585 48.6894Z",
    fill: "url(#paint8_linear_229_4922)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.613 42.9339C137.707 43.1033 137.353 44.2132 137.995 44.8758L142.125 49.143C142.402 49.4293 142.807 49.5528 143.197 49.47L146.447 48.7794C146.9 48.7366 147.325 48.4311 147.459 47.9246L148.359 44.5435C148.459 44.1686 148.364 43.7687 148.107 43.4784L144.232 39.1089C143.628 38.4282 142.512 38.6784 142.256 39.5515L141.42 42.4095L138.613 42.9339Z",
    fill: "url(#paint9_linear_229_4922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_4922",
    x1: 56.0684,
    y1: 0.492188,
    x2: 56.0684,
    y2: 112.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_229_4922",
    x1: 143.017,
    y1: 64.3593,
    x2: 304.189,
    y2: 63.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimeLogoRow);
export default __webpack_public_path__ + "static/media/aime-logo-row.fa40d8a971ecc194b25f651870afa2d1.svg";
export { ForwardRef as ReactComponent };